import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-station-detail',
  templateUrl: './update-station-detail.component.html',
  styleUrls: ['./update-station-detail.component.css']
})
export class UpdateStationDetailComponent implements OnInit {


  userData:any = [];
  userName = null;
  @Input() industryId: string;
  @Input() type: string;
  getStationDetailLoader = false;
  route = '';
  stationDetails = [];
  error = false;
  formErrorStationName = [];
  formErrorStationId = [];
  realStationDetails = {};
  updateStationLoader = false;
  archive = null;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
    }

    this.activeroute.queryParams.subscribe(params => {
      if(params['archive']){
        this.archive = params['archive'];
      }
    });

    this.getStationDetail();
  }


  getStationDetail(){
    this.getStationDetailLoader = true;
    this.route  = 'get-ind-station-details';
    const token    = localStorage.getItem('userToken');
    this.stationDetails = [];
    this.realStationDetails = {};

    let data = {'industry_id':this.industryId, 'is_archive':this.archive};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }

      if(response.status == 200){
        this.getStationDetailLoader = false;

        if(response.data.length){
          this.stationDetails = response.data;
          this.realStationDetails = JSON.stringify(response.data);

        }
      }

    });
  }



  delete(id){
    const apiRoute = "delete-station";

    Swal({
      title: 'Are You Sure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        const param= {
          id: id
        }
        const token    = localStorage.getItem('userToken');
        this._service.postRequestCreator(param, apiRoute, token).subscribe((response: any) => {

          if(response.status == 200){
            Swal('Success', 'Station deleted successfully', 'success');
            // location.reload();
            this.getStationDetail();

          } else if(response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
            // location.reload();
          }else{
            Swal('Oops...', 'Something went wrong!', 'error');
          }

        });

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal(
          'Cancelled',
          'Delete Cancelled.',
          'error'
        );
      }
    });
  }


    validateStation(stationNumber){

    this.error = false;

    if(this.stationDetails[stationNumber]['name'].trim() && this.stationDetails[stationNumber]['name'].trim() != ' '){
      this.formErrorStationName[stationNumber] = '';
    }else{
      this.formErrorStationName[stationNumber] = 'Station name is required';
      this.error = true;
    }

    if(this.stationDetails[stationNumber]['vendor_station_id'].trim() && this.stationDetails[stationNumber]['vendor_station_id'].trim() != ' '){
      this.formErrorStationId[stationNumber] = '';
    }else{
      this.formErrorStationId[stationNumber] = 'Station id is required';
      this.error = true;
    }

    if(this.error){
      Swal('Error', 'Please provide complete details!', 'error');
    }else{

      this.updateStationLoader = true;
      this.route  = 'update-station-detail';
      const token = localStorage.getItem('userToken');
      this.stationDetails[stationNumber]['real_dataset'] = this.realStationDetails;
      this.stationDetails[stationNumber]['user_id'] = this.userName;
      this.stationDetails[stationNumber]['row_number'] = stationNumber;
      let data = this.stationDetails[stationNumber];

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        this.updateStationLoader = false;
        if(response.status == 200){
          this.getStationDetail();
          Swal('Success', 'Station details updated successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }

}
